module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms76x"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.receivedHrms76xIndex,
      "columnEvent": _vm.columnEvent,
      "csvExportDisp": true,
      "searchBoxAlias": "hrms76x",
      "callSearchEvent": _vm.callSearchEvent
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-110c5a10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms76x/component.vue
// module id = 3564
// module chunks = 1